export var WlCurrency;
(function (WlCurrency) {
    WlCurrency["USD"] = "USD";
    WlCurrency["EUR"] = "EUR";
})(WlCurrency || (WlCurrency = {}));
export const WlCurrencySymbolMap = new Map([
    [WlCurrency.USD, '$'],
    [WlCurrency.EUR, '€'],
]);
